import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, requiredMenu, adminOnly }) => {
  const { user, token } = useSelector((state) => state.auth);
  const location = useLocation();

  // Not logged in - redirect to login
  if (!user || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Superadmin has access to everything
  if (user.role === 'superadmin') {
    return children;
  }

  // Admin-only pages are never accessible to members
  if (adminOnly && user.role === 'member') {
    return <Navigate to="/" replace />;
  }

  // If no specific menu required, allow access
  if (!requiredMenu) {
    return children;
  }

  // Check if user has the required menu in their allowedMenus
  const allowedMenus = user.allowedMenus || [];
  const hasAccess = allowedMenus.some(
    menu => menu.toLowerCase() === requiredMenu.toLowerCase()
  );

  if (!hasAccess) {
    // Redirect to dashboard instead of logging out
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
